<script setup>
import { reactive, ref, useTemplateRef } from 'vue'
import * as v from 'valibot'
import { useStoryblokStore } from '@/stores/storyblok'


const storyblokStore = useStoryblokStore()

const items = ref([
  {
    label: 'Homepage',
    value: 'homepage',
    disabled: true,
  },
  { label: 'Contact', value: 'contact' },
  { label: 'Vacatures', value: 'vacatures' },
  { label: 'Job alerts', value: '_default/_unsubscribe' },
  { label: 'Vacancy template', value: '_default/_vacancy' },
  { label: 'Cookies', value: 'cookies' },
  { label: 'Open sollicitatie', value: 'open-sollicitatie' },
  { label: 'Privacy', value: 'privacy' },
  { label: 'Stage', value: 'stage' },
])

const StructureSchema = v.object({
  pages: v.pipe(v.array(v.string()), v.minLength(1, 'Select at least one page')),
})
const state = reactive({
  pages: storyblokStore.pages || items.value.map((item) => item.value),
})

const form = useTemplateRef('form')
defineExpose({
  async validate() {
    const validData = await form.value.validate()
    if (validData) {
      storyblokStore.pages = validData.pages
      return true
    }
    return false
  },
})
</script>

<template>
  <h2 class="text-primary text-3xl mb-8">Site structure</h2>
  <UForm ref="form" :schema="StructureSchema" :state="state" class="w-fit space-y-6">
    <UFormField name="pages">
      <UCheckboxGroup
        legend="Select the pages you want to include in your site:"
        v-model="state.pages"
        color="secondary"
        :items="items"
        :ui="{ fieldset: 'grid grid-cols-2 gap-4 gap-x-24', legend: 'mb-4' }"
      ></UCheckboxGroup>
    </UFormField>
  </UForm>
</template>
